import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Status from './status.jsx';

import Icon from './icon.jsx';

const StatusSummaryWrapper = ({
    actionRequiredType,
    children,
    skipActionRequired,
    statusSummary,
}) => {
    const headerClasses = classnames(
        'align-items-center flex justify-center licorice t3',
        {
            ptm: statusSummary,
            pvm: !statusSummary,
        }
    );

    return (
        <div className="flex justify-center r-phl">
            <div className="bas bg-ice border-toothpaste r-mbl r-mhl r-size3of5">
                <div>
                    <div className={headerClasses}>
                        <span className="mrm">
                            <Icon />
                        </span>
                        Trygg betaling
                    </div>

                    <Status
                        actionRequiredType={actionRequiredType}
                        skipActionRequired={skipActionRequired}
                    >
                        {statusSummary}
                    </Status>

                    <div>{children}</div>
                </div>
            </div>
        </div>
    );
};

StatusSummaryWrapper.propTypes = {
    actionRequiredType: PropTypes.oneOf(['POSITIVE', 'NEGATIVE']),
    children: PropTypes.node.isRequired,
    skipActionRequired: PropTypes.bool,
    statusSummary: PropTypes.node,
};

export default StatusSummaryWrapper;



// WEBPACK FOOTER //
// ./safeTrade/status/statusSummaryWrapper.jsx